import { DomSanitizer } from "@angular/platform-browser";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'safeResourceString',
})
export class SafeResourceStringPipe implements PipeTransform {

  constructor(private sanitized: DomSanitizer) {}

  transform(value: string) {
    return this.sanitized.bypassSecurityTrustResourceUrl(value);
  }

}
